var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirstAidBox = function SvgFirstAidBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "first_aid_box_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24.093v24.093H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#first_aid_box_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.578 13.797v2.092q0 .191.138.33a.45.45 0 0 0 .33.139.45.45 0 0 0 .332-.139.45.45 0 0 0 .138-.33v-2.092h2.092a.45.45 0 0 0 .33-.138.45.45 0 0 0 .139-.331.45.45 0 0 0-.139-.331.45.45 0 0 0-.33-.14h-2.092v-2.09a.45.45 0 0 0-.138-.33.45.45 0 0 0-.331-.14.45.45 0 0 0-.331.14.45.45 0 0 0-.138.33v2.09H9.486a.45.45 0 0 0-.331.14.45.45 0 0 0-.138.33q0 .193.138.332a.45.45 0 0 0 .33.138zm-5.74 5.506q-.642 0-1.058-.416t-.416-1.057V8.867q0-.639.416-1.056.416-.416 1.057-.416h3.585V6.264q0-.64.416-1.056.417-.417 1.056-.417H13.2q.64 0 1.056.417.416.416.416 1.056v1.13h3.585q.642 0 1.057.417.416.417.416 1.056v8.963q0 .641-.416 1.057t-1.057.416zM10.36 7.395h3.372V6.264a.52.52 0 0 0-.15-.384.52.52 0 0 0-.384-.15h-2.305a.52.52 0 0 0-.384.15.52.52 0 0 0-.15.384zM5.837 18.363h12.42q.235 0 .384-.148.15-.15.149-.385V8.867a.52.52 0 0 0-.149-.383.52.52 0 0 0-.385-.15H5.837a.52.52 0 0 0-.385.15.52.52 0 0 0-.148.383v8.963q0 .235.148.385.15.148.385.148"
  }))));
};
export default SvgFirstAidBox;